import { useQuery } from "@tanstack/react-query";
import { workerService } from "@safers/api";
import { parseCurrentWeather, parseHourlyWeather } from "@/services/weather";

/** 체감온도계는 센서마다 켜진 시각부터 10분 주기로 잰다. */
const REFRESH_MS = 10 * 60_000;

async function fetchDashboard(uuid: string) {
  const { weather, heatIndexSensors } = await workerService.getWorkerDashboard(uuid);
  const groups = weather ?? [];
  return {
    currentWeather: parseCurrentWeather(groups),
    hourlyWeather: parseHourlyWeather(groups),
    heatIndexSensors: heatIndexSensors ?? [],
  };
}

/**
 * 근로자 대시보드(날씨 + 현장 체감온도계)를 불러오고 주기적으로 갱신한다.
 *
 * - 10분마다 다시 부른다.
 * - 화면이 다시 보이면 바로 다시 부른다.
 * - 실패하면 이전 값을 그대로 두고 다음 주기에 다시 부른다.
 */
export function useWorkerDashboard(uuid: string) {
  return useQuery({
    queryKey: ["worker-dashboard", uuid],
    queryFn: () => fetchDashboard(uuid),
    enabled: uuid !== "",
    refetchInterval: REFRESH_MS,
    refetchOnWindowFocus: "always",
  });
}
